module.exports = __webpack_public_path__ + "25bf20d4da9198647546dbd9d780d0fb.svg";